import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import GelLaneDepositImage from "./img/gel-side.svg";
import { Image } from "@learningblocks/shared-components/lib/Image";

import P2Plunger from "./img/P2-Plunger.svg";
import P2NoTip from "./img/P2.svg";
import P2Tip from "./img/P2-Tip.svg";
import P2TipSolution from "./img/P2-Tip-Solution-Blue.svg";

import P20Plunger from "./img/P20-Plunger.svg";
import P20NoTip from "./img/P20.svg";
import P20Tip from "./img/P20-Tip.svg";
import P20TipSolution from "./img/P20-Tip-Solution-Blue.svg";

import P200Plunger from "./img/P200-Plunger.svg";
import P200NoTip from "./img/P200.svg";
import P200Tip from "./img/P200-Tip.svg";
import P200TipSolution from "./img/P200-Tip-Solution-Blue.svg";

import P1000Plunger from "./img/P1000-Plunger.svg";
import P1000NoTip from "./img/P1000.svg";
import P1000Tip from "./img/P1000-Tip.svg";
import P1000TipSolution from "./img/P1000-Tip-Solution-Blue.svg";

const images = {
  P2Plunger: P2Plunger,
  P2NoTip: P2NoTip,
  P2Tip: P2Tip,
  P2TipSolution: P2TipSolution,
  P20Plunger: P20Plunger,
  P20NoTip: P20NoTip,
  P20Tip: P20Tip,
  P20TipSolution: P20TipSolution,
  P200Plunger: P200Plunger,
  P200NoTip: P200NoTip,
  P200Tip: P200Tip,
  P200TipSolution: P200TipSolution,
  P1000Plunger: P1000Plunger,
  P1000NoTip: P1000NoTip,
  P1000Tip: P1000Tip,
  P1000TipSolution: P1000TipSolution,
};

export function GelLaneDeposit(props) {
  const { t } = useTranslation();

  const getPipetteAltText = (type) => {
    let alt = "";
    switch (type) {
      case "P2":
        alt = t("P2Micropipette.string");
        break;
      case "P20":
        alt = t("P20Micropipette.string");
        break;
      case "P200":
        alt = t("P200Micropipette.string");
        break;
      case "P1000":
        alt = t("P1000Micropipette.string");
        break;
    }
    return alt;
  };

  return (
    <div className={props.className}>
      <div className={`${props.className}_image`}>
        {props.pipetteId !== null ? (
          <div className="imageWrapper">
            <img
              //ref={ref}
              className={props.type + "-pipette pipettePlunger"}
              src={
                images[
                  props.interactionProps.pipettes[props.pipetteId - 1].type +
                    "Plunger"
                ]
              }
              alt={getPipetteAltText(
                props.interactionProps.pipettes[props.pipetteId - 1].type
              )}
            />
            <img
              className={props.type + "-pipette pipette"}
              src={
                props.interactionProps.pipettes[props.pipetteId - 1].tipAttached
                  ? props.interactionProps.pipettes[props.pipetteId - 1]
                      .solution !== null
                    ? images[
                        props.interactionProps.pipettes[props.pipetteId - 1]
                          .type + "TipSolution"
                      ]
                    : images[
                        props.interactionProps.pipettes[props.pipetteId - 1]
                          .type + "Tip"
                      ]
                  : images[
                      props.interactionProps.pipettes[props.pipetteId - 1]
                        .type + "NoTip"
                    ]
              }
              alt={getPipetteAltText(
                props.interactionProps.pipettes[props.pipetteId - 1].type
              )}
            />
          </div>
        ) : null}
        {!props.lanes[props.selectedLane].empty ? (
          <div
            className="liquid"
            //ref={ref}
          ></div>
        ) : null}
        <Image
          src={GelLaneDepositImage}
          alt={t("ControlsPanel.string")}
          className={`${props.className}_image_main`}
        />
      </div>
    </div>
  );
}

GelLaneDeposit.propTypes = {
  /**
   * ClassName to set on component
   */
  className: PropTypes.string,
  /**
   * Current rpm value set
   */
  rpmValue: PropTypes.number,
  /**
   * Current Runtime set
   */
  timeValue: PropTypes.instanceOf(Date),
  /**
   * Time left for centrifuge to run to completion
   */
  timeLeft: PropTypes.instanceOf(Date),
  /**
   * Function to set RPM value
   */
  setRPM: PropTypes.func,
  /**
   * Function to set Run Time
   */
  setTimeValue: PropTypes.func,
  /**
   * Function to invoke when to  run the Centrifuge
   */
  runCentrifuge: PropTypes.func,
};

GelLaneDeposit.defaultProps = {};
